export const elements = {
    mainNavigation          : $('header.n7w-main-header'),
    secondaryNavigation     : $('nav.n7w-sub-nav'),
    fixedHeaderContent       : $('header.fixed-header'),
    belowNavHeroContent     : $('.sub-nav-hero'),
};

// Media Query Break Points
export const screenSizes = {
    smallX      : 480,
    small       : 768,
    medium      : 992,
    large       : 1200,
};

export const wonderSlider = {
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    centerMode: true,
    centerPadding: '0px',
    arrows: true,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    dots: true,
    focusOnSelect: true,
    infinite: true,
    responsive: [
    {
        breakpoint: screenSizes.smallX,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '7vw',
            slidesToScroll: 1,
            dots: true,
        },
    },
    {
        breakpoint: screenSizes.small,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '20vw',
            slidesToScroll: 1,
            dots: false,
        },
    },
    {
        breakpoint: screenSizes.medium,
        settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: true,
            centerPadding: '10vw',
            slidesToScroll: 1,
            dots: true,
        },
    },
    {
        breakpoint: screenSizes.large,
        settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: true,
            centerPadding: '8vw',
            slidesToScroll: 3,
            dots: true,
        },
    },
    {
        breakpoint: 999999,
        settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: true,
            centerPadding: '10%',
            slidesToScroll: 3,
            dots: true,
        },
    },
    ],
};

export const headerWonderSlider = {
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    centerMode: true,
    centerPadding: '0px',
    arrows: true,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    dots: true,
    focusOnSelect: true,
    infinite: false,
    responsive: [
    {
        breakpoint: screenSizes.smallX,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '0px',
            slidesToScroll: 1,
            dots: false,
        },
    },
    {
        breakpoint: screenSizes.small,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '40px',
            slidesToScroll: 1,
            dots: false,
        },
    },
    {
        breakpoint: screenSizes.medium,
        settings: {
            slidesToShow: 1,
            initialSlide: 1,
            centerMode: true,
            centerPadding: '40px',
            slidesToScroll: 1,
            dots: false,
        },
    },
    {
        breakpoint: screenSizes.large,
        settings: {
            slidesToShow: 1,
            initialSlide: 0,
            centerMode: true,
            centerPadding: '20vw',
            slidesToScroll: 1,
            dots: false,
        },
    },
    {
        breakpoint: 999999,
        settings: {
            slidesToShow: 3,
            initialSlide: 0,
            centerMode: true,
            centerPadding: '0px',
            slidesToScroll: 1,
            dots: false,
        },
    },
    ],
};

export const latestNewsSlider = {
    slidesToShow: 1,
    autoplay: false,
    centerMode: true,
    centerPadding: '40px',
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    responsive: [
      {
            breakpoint: screenSizes.smallX,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '10vw',
                slidesToScroll: 1,
                dots: true,
            },
    },
      {
            breakpoint: screenSizes.small,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '25vw',
                slidesToScroll: 1,
                dots: true,
            },
    },
      {
            breakpoint: screenSizes.medium,
            settings: {
                slidesToShow: 2,
                initialSlide: 1,
                centerMode: true,
                centerPadding: '10vw',
                slidesToScroll: 1,
                dots: true,
            },
    },
      {
            breakpoint: screenSizes.large,
            settings: {
                slidesToShow: 3,
                centerMode: false,
                centerPadding: '40px',
                slidesToScroll: 3,
                dots: true,
            },
    },
      {
            breakpoint: 999999,
            settings: {
                slidesToShow: 3,
                centerMode: false,
                centerPadding: '40px',
                slidesToScroll: 3,
                dots: true,
            },
    },
    ],
};

export const votingPhasesSlider = {
    slidesToShow: 1,
    dots: true,
    arrows: false,
    infinite: false,
    responsive: [
    {
        breakpoint: screenSizes.smallX,
        settings: {
            slidesToShow: 1,
            centerMode: false,
        },
    },
    {
        breakpoint: screenSizes.small,
        settings: {
            centerMode: false,
        },
    },
    {
        breakpoint: screenSizes.medium,
        settings: {
            centerMode: true,
            centerPadding: '100px',
        },
    },
    {
        breakpoint: screenSizes.large,
        settings: {
            centerMode: true,
            centerPadding: '150px',
        },
    },
    {
        breakpoint: 999999,
        settings: {
            centerMode: true,
            centerPadding: '150px',
        },
    },
    ],
};

export const mediaSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    infinite: true,
    asNavFor: '.media-slider-nav',
};

export const compactMediaSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: false,
    infinite: true,
    dots: true,
};

export const navMediaSlider = {
    asNavFor: '.media-slider',
    slidesToShow: 2,
    initialSlide: 0,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '40px',
    focusOnSelect: true,
    infinite: true,
    responsive: [
    {
        breakpoint: screenSizes.smallX,
        settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '10px',
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: screenSizes.small,
        settings: {
            slidesToShow: 3,
            centerMode: true,
            centerPadding: '50px',
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: screenSizes.medium,
        settings: {
            slidesToShow: 4,
            centerMode: true,
            centerPadding: '40px',
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: screenSizes.large,
        settings: {
            slidesToShow: 5,
            centerMode: true,
            centerPadding: '0px',
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: 999999,
        settings: {
            slidesToShow: 5,
            centerMode: true,
            centerPadding: '0px',
            slidesToScroll: 1,
        },
    },
    ],
};
